import { unifiedOrderListQuerySchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrdersPage } from '@/features/orders/orders-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/commandes` — écran Commandes (`02` §3), l'écran central : commandes
 * Shopify **et** factures Pennylane dans la même liste. Route fille de
 * `_authenticated` (garde d'authentification unique, `README-shell.md`).
 *
 * `validateSearch` réutilise `unifiedOrderListQuerySchema` de `@flux/shared`
 * — pagination, tri, période, origine, statut unifié (multi), recherche
 * libre, opération, avertissements — étendu du seul alias `store`, que
 * `useOriginFilter` écrit et que les liens existants (alertes, tableau de
 * bord) utilisent encore.
 */
const ordersSearchSchema = z.object({
  ...unifiedOrderListQuerySchema.shape,
  store: z.string().optional(),
});

export const ordersRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/commandes',
  validateSearch: (search: Record<string, unknown>) => ordersSearchSchema.parse(search),
  component: OrdersPage,
});
